import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "../data/content";
import { Reveal, Eyebrow } from "./Reveal";

export const Services = () => (
  <section data-testid="services-section" id="services" className="relative py-28 lg:py-40 bg-charcoal-900">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
        <div className="lg:col-span-8">
          <Reveal>
            <Eyebrow testid="services-eyebrow">How I Help</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-6 leading-[1.05]">
              Bring me in when growth <span className="italic text-gold-gradient">has to pay off.</span>
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.2} className="lg:col-span-4">
          <p className="text-cream/55 text-base sm:text-lg leading-relaxed">
            Founders hire me for one reason: to turn marketing from a cost centre into a
            predictable growth engine. Here's where I do that best.
          </p>
        </Reveal>
      </div>

      <div className="grid sm:grid-cols-2 gap-6">
        {SERVICES.map((s, i) => (
          <motion.div
            key={s.n}
            data-testid={`service-card-${i}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: (i % 2) * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="group relative border border-white/10 rounded-3xl p-8 lg:p-10 bg-charcoal-800/40 hover:border-gold/30 transition-colors duration-500 overflow-hidden"
          >
            <div className="flex items-start justify-between gap-4">
              <span className="font-serif text-5xl text-gold/25 leading-none">{s.n}</span>
              <ArrowRight className="text-gold/0 group-hover:text-gold -translate-x-2 group-hover:translate-x-0 transition-all duration-500" size={22} />
            </div>
            <h3 className="font-serif text-2xl sm:text-3xl text-cream mt-6">{s.title}</h3>
            <p className="text-cream/55 text-sm sm:text-base leading-relaxed mt-4">{s.desc}</p>
            <div className="flex flex-wrap gap-2 mt-6">
              {s.points.map((p, j) => (
                <span key={j} className="px-3 py-1.5 rounded-full border border-white/10 text-cream/60 text-xs">{p}</span>
              ))}
            </div>
            <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-gold group-hover:w-full transition-all duration-700" />
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
